import { dateToyyyyMMdd } from "@/util/date";

/**
 * "Dokumentation gælder fra" lader sekretariatet tælle kurser med, der er holdt før
 * afgørelsen — typisk fra starten på advokatens aktuelle efteruddannelsesperiode, så kurser
 * fra tiden mellem periodens afslutning og afgørelsen ikke går tabt. Indfrielsesperioden og
 * fristen regnes stadig fra afgørelsesdatoen.
 */
export const DOKUMENTATION_GAELDER_FRA_LABEL = "Dokumentation gælder fra";

export const dokumentationGaelderFraInfo = (afgoerelse: "påbud" | "pålæg") =>
  `Kursusbeviser for kurser afholdt fra og med denne dato og til indfrielsesperiodens ` +
  `udløb kan bruges til at opfylde ${afgoerelse === "påbud" ? "påbuddet" : "pålægget"}. ` +
  `Normalt starten på advokatens aktuelle efteruddannelsesperiode. Er feltet tomt, ` +
  `gælder dokumentationen fra afgørelsesdatoen. Feltet kan ikke ændres, når advokaten ` +
  `har indberettet.`;

export interface EfteruddannelsesperiodeInterval {
  fraDato: string;
  /** Eksklusiv — dagen efter periodens sidste dag. */
  tilDato: string;
}

/**
 * Starten på den periode, afgørelsesdatoen ligger i, som "yyyy-MM-dd" — eller null, når
 * der ingen afgørelsesdato er, eller den ikke ligger i en kendt periode. Datoerne
 * sammenlignes som tekst, så tidszonen ikke kan flytte en dag over et periodeskel.
 */
export const foreslaaDokumentationGaelderFra = (
  perioder: EfteruddannelsesperiodeInterval[],
  afgoerelsesdato: Date | null,
): string | null => {
  if (!afgoerelsesdato) return null;
  const dag = dateToyyyyMMdd(afgoerelsesdato);
  const periode = perioder.find(
    (p) => p.fraDato.slice(0, 10) <= dag && dag < p.tilDato.slice(0, 10),
  );
  return periode ? periode.fraDato.slice(0, 10) : null;
};

/** Backenden afviser en dato efter afgørelsesdatoen; formularen fanger den først. */
export const erEfterAfgoerelsesdato = (
  dokumentationGaelderFra: Date | null,
  afgoerelsesdato: Date | null,
): boolean =>
  !!dokumentationGaelderFra &&
  !!afgoerelsesdato &&
  dateToyyyyMMdd(dokumentationGaelderFra) > dateToyyyyMMdd(afgoerelsesdato);
